import { Actions, createEffect, ofType } from '@ngrx/effects';
import paymentsActions from './payments.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Injectable } from '@angular/core';
import { FormsService } from '../../services/forms.service';
import AppError from '../../model/app-error';

@Injectable()
export class PaymentsEffects {
  fetchTransactionStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(paymentsActions.fetchTransactionStart),
      switchMap(({ transactionGUID }) =>
        this.apiService.getPaymentsTransaction(transactionGUID).pipe(
          map((success) => paymentsActions.fetchTransactionSuccess({ success })),
          catchError((error: AppError) => of(paymentsActions.fetchTransactionError({ error }))),
        ),
      ),
    ),
  );

  fetchPolicyStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(paymentsActions.fetchPolicyStart),
      switchMap(({ hashCode }) =>
        hashCode
          ? this.formsService.paymentPolicyApi$.pipe(
              switchMap((paymentPolicyApiBody) => this.apiService.postPaymentsPolicy(hashCode, paymentPolicyApiBody)),
              map((success) => paymentsActions.fetchPolicySuccess({ success })),
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              catchError((error: AppError) => of(paymentsActions.fetchPolicyError({ error }))),
            )
          : of(paymentsActions.fetchPolicyError({ error: new AppError('app', null, '') })),
      ),
    ),
  );

  constructor(private apiService: ApiService, private formsService: FormsService, private actions$: Actions) {}
}
